<template>
    <vs-sidebar click-not-close position-right parent="body" default-index="1" color="primary" class="add-new-data-sidebar items-no-padding" spacer v-model="isSidebarActiveLocal">
        <div class="mt-6 flex items-center justify-between px-6">
            <h4>{{ detail__detail? 'DÉTAIL DU' : (Object.entries(this.data).length === 0 ? "NOUVELLE" : "MODIFIER UNE") }} SAISON</h4>
            <feather-icon icon="XIcon" @click.stop="isSidebarActiveLocal = false" class="cursor-pointer"/>
        </div>
        <vs-divider class="mb-0" />
        <VuePerfectScrollbar class="scroll-area--data-list-add-new" :settings="settings" :key="$vs.rtl">
            <div class="px-6 py-2" v-if="!detail__detail">
                <p class="mt-5" >Nom <b style="color: #ff6141">*</b> </p>
                <vs-input 
                  :disabled="detail__detail"
                  :danger="error.name || all_errors.name.length ? true : false"
                  v-model="input.name" class="w-full" name="item-code" />
                <span v-if="error.name || all_errors.name.length" class="span-text-validation con-text-validation span-text-validation-danger vs-input--text-validation-span">
                  <p v-for="(err, io) in all_errors.name" :key="io" style="margin-bottom: 4px !important; font-size: 13px">{{err}}</p>
                </span>

                <p class="mt-5" >Date de début<b style="color: #ff6141" v-if="!detail__detail" >*</b> </p>
                <datepicker :disabled="detail__detail" v-model="input.startDate"></datepicker>
                <span v-if="error.startDate || all_errors.startDate.length" class="span-text-validation con-text-validation span-text-validation-danger vs-input--text-validation-span">
                  <p v-for="(err, io) in all_errors.startDate" :key="io" style="margin-bottom: 4px !important; font-size: 13px">{{err}}</p>
                </span>
            </div>

            <vs-list v-if="detail__detail">
              <vs-list-header icon-pack="feather" icon="icon-truck" title="Information"></vs-list-header>
              <vs-list-item icon-pack="feather" icon="icon-check" title="Nom" :subtitle="input.name"></vs-list-item>
              <vs-list-item icon-pack="feather" icon="icon-check" title="Date de début" :subtitle="convertDateTime(new Date(input.startDate)).date"></vs-list-item>
            </vs-list>
        </VuePerfectScrollbar>
        <div v-if="!detail__detail" class="flex flex-wrap items-center p-6" slot="footer">
            <vs-button class="mr-6" @click="submitData" :disabled="!isFormValid">Soumettre</vs-button>
            <vs-button type="border" color="danger" @click="isSidebarActiveLocal = false">Annuler</vs-button>
        </div>
    </vs-sidebar>
</template>

<script>
    var base_self;
    var input_tempon = {
      id: null,
      name: '',
      wording: '',
    };

    import VuePerfectScrollbar from 'vue-perfect-scrollbar';
    import Datepicker from 'vuejs-datepicker';

    export default {
        components: {VuePerfectScrollbar, Datepicker},
        props: {
            isSidebarActive: {
              type: Boolean,
              required: true
            },
            data: {
              type: Object,
              default: () => {},
            },
        },
        data() {
            return {
                initialNoError: {
                  name: false,
                  startDate: false,
                  wording: false,
                },
                error: {
                  name: false,
                  startDate: false,
                  wording: false,
                },
                all_errors: {
                  name: [],
                  startDate: [],
                  wording: [],
                },
                input: JSON.parse(JSON.stringify(input_tempon)),
                input1: JSON.parse(JSON.stringify(input_tempon)),
                detail__detail: false,
                settings: { // perfectscrollbar settings
                    maxScrollbarLength: 60,
                    wheelSpeed: .60,
                },
            }
        },
        computed: {
            isSidebarActiveLocal: {
                get() {
                    return this.isSidebarActive
                },
                set(val) {
                    if(!val) {
                        this.$emit('closeSidebar')
                    }
                }
            },
            isFormValid() {
              var is_valide = true;
              if (!this.input.name || this.input.name === '') is_valide = false;
              if (!this.input.startDate || this.input.startDate === '') is_valide = false;
              return is_valide;
            }
        },
        methods: {
            verification_name () {
              let libelle = 'Le nom est réquis.';
              if (!base_self.initialNoError.name) return false;
              if (base_self.input.name.length === 0) {
                base_self.all_errors.name.push(libelle)
              } else {
                base_self.all_errors.name = base_self.all_errors.name.filter(e => e !== libelle);
              }
            },
            verification_startDate () {
              let libelle = 'La date de début est réquise.';
              if (!base_self.initialNoError.startDate) return false;
              if (base_self.input.startDate.length === 0) {
                base_self.all_errors.startDate.push(libelle)
              } else {
                base_self.all_errors.startDate = base_self.all_errors.startDate.filter(e => e !== libelle);
              }
            },
            convertDateTime (dateTimeSysteme) {
              let date = dateTimeSysteme.getFullYear() + '-' + ('0' + (dateTimeSysteme.getMonth() + 1)).slice(-2) + '-' + ('0' + dateTimeSysteme.getDate()).slice(-2);
              let time = ('0' + dateTimeSysteme.getHours()).slice(-2) + ':' + ('0' + dateTimeSysteme.getMinutes()).slice(-2) + ':' + ('0' + dateTimeSysteme.getSeconds()).slice(-2);
              let dateTime = date + ' ' + time;

              return { dateTime, date, time };
            },
            verification_wording () {
              let libelle = 'La description est réquis.';
              if (!base_self.initialNoError.wording) return false;
              if (base_self.input.wording.length === 0) {
                base_self.all_errors.wording.push(libelle)
              } else {
                base_self.all_errors.wording = base_self.all_errors.wording.filter(e => e !== libelle);
              }
            },
            async submitData() {
                let convertDateTime = function (dateTimeSysteme) {
                  let date = dateTimeSysteme.getFullYear() + '-' + ('0' + (dateTimeSysteme.getMonth() + 1)).slice(-2) + '-' + ('0' + dateTimeSysteme.getDate()).slice(-2);
                  let time = ('0' + dateTimeSysteme.getHours()).slice(-2) + ':' + ('0' + dateTimeSysteme.getMinutes()).slice(-2) + ':' + ('0' + dateTimeSysteme.getSeconds()).slice(-2);
                  let dateTime = date + ' ' + time;

                  return { dateTime, date, time };
                };

                var input = JSON.parse(JSON.stringify(this.input));

                input.startDate = convertDateTime(new Date(input.startDate)).date;
                
                if(!input.id) {     
                    base_self.$store.state.season_post(input)
                      .then((response) => {
                        if (response.data.state) {
                          window.getAgroTrack.success('La saison est ajoutée avec succès.', response);
                          window.getAppSeasons.getSeasons();
                          this.$emit('closeSidebar');
                          this.initValues()
                        } else {
                          window.getAgroTrack.error({ message: response.data.message });
                        }
                      })
                      .catch((error) => { 
                        console.log('error: ', error)
                      });
                  
                } else if (input.id) {
                    base_self.$store.state.season_update(input, input.id)
                      .then((response) => { 
                          
                        if (response.data.state) {
                          window.getAgroTrack.success('La saison est modifiée avec succès.', response);
                          window.getAppSeasons.getSeasons();
                          this.$emit('closeSidebar');
                          this.initValues()
                        } else {
                          window.getAgroTrack.error({ message: response.data.message });
                        }
                      })
                      .catch((error) => { 
                        console.log('error: ', error)
                      });
                }
            },
            initValues() {
                this.initialNoError = {
                  name: false,
                  startDate: false,
                  wording: false,
                };
                base_self.input = JSON.parse(JSON.stringify(input_tempon));
                base_self.input1 = JSON.parse(JSON.stringify(input_tempon));
                base_self.detail__detail = false;
                // window.getSeasons.sidebarData.detail__detail = false;
            }
        },
        watch: {
          input: {
            handler () {
              if (base_self.input1.name !== base_self.input.name) 
              {
                base_self.initialNoError.name = true
                base_self.verification_name()
              }

              if (base_self.input1.startDate !== base_self.input.startDate) 
              {
                base_self.initialNoError.startDate = true
                base_self.verification_startDate()
              }

              /* if (base_self.input1.wording !== base_self.input.wording) 
              {
                base_self.initialNoError.wording = true
                base_self.verification_wording()
              } */
              base_self.input1 = JSON.parse(JSON.stringify(base_self.input));
            },
            deep: true
          },
          async isSidebarActive() {
              this.initValues();
              if (base_self.data && base_self.data.id) {
                // Object.assign(base_self.input, JSON.parse(JSON.stringify(base_self.data)));
                base_self.input = JSON.parse(JSON.stringify(base_self.data));
              }
              /* if(window.getAppSeasons.sidebarData.id) {
                  let response = await base_self.$store.state.categories_requests_detail({}, window.getAppSeasons.sidebarData.id);

                  this.input = JSON.parse(JSON.stringify(response.data));
                  console.log('categories_requests_detail response :    ::::::::::::::::::::::::', response);

                  this.detail__detail = window.getAppSeasons.detail__detail;
              } */
          }
        },
        created() {
            window.EditCategory = this;
            base_self = this;
            base_self.initValues()
        }

    }
</script>

<style lang="scss" scoped>
    .add-new-data-sidebar {
        ::v-deep .vs-sidebar--background {
            z-index: 52010;
        }

        ::v-deep .vs-sidebar {
            z-index: 52010;
            width: 400px;
            max-width: 90vw;

            .img-upload {
                margin-top: 2rem;

                .con-img-upload {
                    padding: 0;
                }

                .con-input-upload {
                    width: 100%;
                    margin: 0;
                }
            }
        }
    }

    .scroll-area--data-list-add-new {
        // height: calc(var(--vh, 1vh) * 100 - 4.3rem);
        height: calc(var(--vh, 1vh) * 100 - 16px - 45px - 82px);
        
    }
</style>